import {message, Space} from "antd";
import {AddVariantButton} from "../add-variant-button";
import {ProductVariantsListItemFormFields} from "../variant-list-item";
import {ProductVariantsFormFieldsProps, ProductVariantsFormValues} from "../types";
import {useFieldArray, useFormContext} from "react-hook-form";
import {FormFieldError} from "../../../../../design-system/form-field";
import {useVariantListAccordion} from "../hooks/use-variant-list-accordion";
import {variantListAccordionReducer} from "../reducers/accordion";
import {usePricingCurrencies} from "@/features/currencies";
import {ProductPricingFormFieldsType} from "../../pricing/types";

export type ProductVariantsListFormFieldsProps = {
  productCurrencies: ProductPricingFormFieldsType["currencies"];
  productSelectedPriceType: "paid" | "free";
  hydratedRef: ProductVariantsFormFieldsProps["hydratedRef"];
};

export function ProductVariantsListFormFields({
  productCurrencies,
  productSelectedPriceType,
  hydratedRef,
}: ProductVariantsListFormFieldsProps) {
  const pricingCurrencies = usePricingCurrencies();
  const {openIndexes, toggleIndex, resetState} = useVariantListAccordion({
    reducer: variantListAccordionReducer,
  });
  const {
    control,
    formState: {errors},
    clearErrors,
    watch,
  } = useFormContext<ProductVariantsFormValues>();
  const {fields, remove, append} = useFieldArray({
    control,
    name: "variants",
  });
  const isBankConnected = pricingCurrencies.connectedBankStatus.isBankConnected;

  function openAccordion() {
    // console.log({watch: watch("variants").length});
    if (watch("variants").length === 0) {
      resetState();
      toggleIndex(0);
    } else {
      toggleIndex(watch("variants").length - 1);
    }
  }

  function handleAddVariant() {
    if (fields.length < 5) {
      clearErrors("variants");
      if (watch("variants").length === 0) {
        resetState();
      }
      append({
        variant_id: undefined,
        name: "",
        options: [
          {
            variant_option_id: undefined,
            name: "Option 1",
            priceType: isBankConnected ? "paid" : "free",
            currencies:
              productSelectedPriceType === "free"
                ? [
                    {
                      currency: "NGN",
                      price: 100,
                    },
                  ]
                : productCurrencies.length > 0
                ? [
                    {
                      currency: productCurrencies[0].callPriceCurrency,
                      price: productCurrencies[0].callPrice,
                    },
                  ]
                : [
                    {
                      currency: "NGN",
                      price: 100,
                    },
                  ],
          },
        ],
      });
      openAccordion();
    } else {
      message.error("You can only add 5 variants");
    }
  }

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        {fields.map((item, index) => (
          <ProductVariantsListItemFormFields
            index={index}
            item={item}
            remove={remove}
            key={item.id}
            openIndexes={openIndexes}
            toggleIndex={toggleIndex}
            productCurrencies={productCurrencies}
            productSelectedPriceType={productSelectedPriceType}
            hydratedRef={hydratedRef}
          />
        ))}
      </Space>
      <FormFieldError errorMessage={errors.variants?.message} />
      <AddVariantButton
        handleAddVariant={handleAddVariant}
        lengthOfFields={fields.length}
      />
    </Space>
  );
}
